
const digest = '8084cb7c799d54c09eadbaba3d4489ce12c2c24f91f3f6199cee99e390e1d8c1';
const classes = {"wrapper":"_wrapper_1vfev_1","title":"_title_1vfev_7","value":"_value_1vfev_10","button":"_button_1vfev_13","moreInfo":"_moreInfo_1vfev_18"};
const css = `._wrapper_1vfev_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 15px;
}
._wrapper_1vfev_1 ._title_1vfev_7 {
  font-weight: 500;
}
._wrapper_1vfev_1 ._value_1vfev_10 {
  font-weight: 500;
}
._wrapper_1vfev_1 ._button_1vfev_13 {
  width: fit-content;
  min-width: 100px;
  margin-top: 15px;
}
._wrapper_1vfev_1 ._moreInfo_1vfev_18 {
  color: #666;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  